import { useFlag } from '@unleash/proxy-client-react'
import { Link } from 'react-router-dom'
import config from '../../../../../config'
import { Actions, Content, Message, SliderImage, SliderImageWrapper, StyledButton, Title, TitleHighlight, Wrapper } from './styles'

export default function Slide() {
  const {
    appUrl: { billing }
  } = config
  const isNewCheckoutVisible = useFlag('isNewCheckoutVisible')
  return (
    <Wrapper>
      <Content>
        <Title variant="h1">
          Make group sharing a <TitleHighlight>team sport</TitleHighlight>
        </Title>
        <Message>
          New Group Buckets works across iOS and Android devices perfectly, letting parents upload and share photos & videos back and forth of every
          game. So, you&apos;ll never miss that shot of your superstar&apos;s game-winning goal again!
        </Message>
        <Actions>
          <StyledButton
            color="inherit"
            component={Link}
            data-test="carousel-share-signup"
            to={isNewCheckoutVisible ? 'auth/register' : `${billing}/?id=sharing&type=trial`}
            variant="outlined"
          >
            Try it today!
          </StyledButton>
        </Actions>
      </Content>
      <SliderImageWrapper>
        <picture>
          <SliderImage
            sizes="(max-width: 1406px) 100vw, 1406px"
            srcSet="
              //content.photobucket.com/img/homepage/homepage-slider-soccer-0701-w200.webp 200w,
              //content.photobucket.com/img/homepage/homepage-slider-soccer-0701-w606.webp 606w,
              //content.photobucket.com/img/homepage/homepage-slider-soccer-0701-w915.webp 915w,
              //content.photobucket.com/img/homepage/homepage-slider-soccer-0701-w1115.webp 1115w,
              //content.photobucket.com/img/homepage/homepage-slider-soccer-0701-w1406.webp 1406w"
            src="//content.photobucket.com/img/homepage/homepage-slider-soccer-0701-w1406.webp"
            alt="5 female soccer players celebrating and sharing a win with Photobucket Group Buckets!"
          />
        </picture>
      </SliderImageWrapper>
    </Wrapper>
  )
}
